// Export the Component Definition for use in Contentful Studio
export {ActivityCardContentfulComponentDefinition} from './ActivityCardContentfulDefinition';
export type {ActivityCardProps} from './ActivityCard';
export {default} from './ActivityCard';
